import type {
  MedicalAidValidationRequest,
  MedicalAidValidationResponse,
  PatientCoverageResponse,
  PatientMedicalAidUpdateRequest,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export interface Params {
  count?: number;
  pageToken?: string;
  status?: string;
  patient?: string;
  subscriber?: string;
  payor?: string;
}

export class CoverageApi {
  public async familyCheck(
    request: MedicalAidValidationRequest,
  ): Promise<MedicalAidValidationResponse> {
    const result = await trpcClient.coverage.familyCheck.query(request);

    return result;
  }

  public async updateCoverage(request: PatientMedicalAidUpdateRequest) {
    const result = await trpcClient.coverage.create.mutate(request);

    return result;
  }

  public async getCoverage(
    patientId: string,
  ): Promise<PatientCoverageResponse> {
    const result = await trpcClient.coverage.getByPatient.query({
      id: patientId,
    });

    return result;
  }
}
